


import React, { useState, useEffect } from 'react';
import {
  Box, Container, Grid, Card, CardContent, Typography, Paper, Avatar,
  LinearProgress, Chip, Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, IconButton, Button, Divider, Alert, Tooltip,
  TextField, ButtonGroup, Snackbar,TablePagination,MenuItem
} from '@mui/material';
import {
  TrendingUp, TrendingDown, LocalPharmacy, Biotech, ShoppingCart,MedicalServices,
  AccessibilityNew,
  Healing,
  HourglassEmpty, CheckCircle, Cancel, AttachMoney, People, Assessment,
  Notifications, ArrowForward, MoreVert, LocalShipping, Warning,
  Refresh, Email, Phone, CalendarToday, ErrorOutline,
  CallSplit, Link as LinkIcon 
} from '@mui/icons-material';
import axios from 'axios';
import { useNavigate } from "react-router-dom";
import  bg from "../Logos/med_background2.png"


const AdminDashboard = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [refreshing, setRefreshing] = useState(false);
  const [error, setError] = useState(null);
  const [partialDataWarning, setPartialDataWarning] = useState(false);
  
  // Snackbar state for non-blocking notifications
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'info' });
  
  // Date filter state
  const [selectedPeriod, setSelectedPeriod] = useState('all');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [customDateMode, setCustomDateMode] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [statusFilter, setStatusFilter] = useState('all');

  // Default dashboard data structure with safe defaults
  const defaultDashboardData = {
    medicineOrders: {
      total: 0, pending: 0, completed: 0, cancelled: 0,
      dispatched: 0, revenue: 0, completion_rate: 0
    },
    diagnosticOrders: {
      total: 0, pending: 0, completed: 0, cancelled: 0,
      report_ready: 0, revenue: 0, completion_rate: 0
    },
     nursingandphysio: {
      total: 0, pending: 0, completed: 0, cancelled: 0,
      report_ready: 0, revenue: 0, completion_rate: 0
    },
    complaints: { total: 0, active: 0, resolved: 0 },
    users: { total: 0, active: 0 },
    recentOrders: [],
    activeUsers: 0,
    totalRevenue: 0,
    revenueGrowth: 0,
    usersGrowth: 0,
    metadata: null
  };
  
  const [dashboardData, setDashboardData] = useState(defaultDashboardData);
  
  const dashboardApi = process.env.REACT_APP_DASHBOARD_ANALYTICS_API;

  useEffect(() => {
    // Set today's date as default
    const today = new Date();
    const todayStr = today.toISOString().split('T')[0];
    setStartDate(todayStr);
    setEndDate(todayStr);
    //fetchDashboardData();
  }, []);

  const fetchDashboardData = async (isRefresh = false) => {
    try {
      if (isRefresh) {
        setRefreshing(true);
      } else {
        setLoading(true);
      }
      setError(null);
      setPartialDataWarning(false);

      // Build query params
      let url = dashboardApi;
      const params = new URLSearchParams();
      
      if (customDateMode && startDate && endDate) {
        params.append('start_date', new Date(startDate).toISOString());
        params.append('end_date', new Date(endDate).toISOString());
      } else {
        params.append('period', selectedPeriod);
      }
      
      if (params.toString()) {
        url += `?${params.toString()}`;
      }

      const response = await axios.get(url, {
        timeout: 30000, // 30 second timeout
        validateStatus: (status) => status < 500, // Accept all non-500 responses
      });

      if (response.data.success) {
        setDashboardData(response.data);
        
        if (isRefresh) {
          setSnackbar({
            open: true,
            message: 'Dashboard data refreshed successfully',
            severity: 'success'
          });
        }
      } else {
        // Partial data scenario
        setPartialDataWarning(true);
        
        // Merge returned data with defaults to ensure all fields exist
        const mergedData = {
          ...defaultDashboardData,
          ...response.data,
        };
        
        setDashboardData(mergedData);
        
        setSnackbar({
          open: true,
          message: 'Dashboard loaded with partial data. Some metrics may be unavailable.',
          severity: 'warning'
        });
      }
    } catch (err) {
      console.error('Dashboard fetch error:', err);
      
      // Network or timeout error
      if (err.code === 'ECONNABORTED') {
        setError('Request timed out. Please check your connection and try again.');
      } else if (err.response?.status >= 500) {
        setError('Server error. Showing cached data if available.');
      } else {
        setError(err.response?.data?.error || 'Failed to load dashboard analytics');
      }
      
      // Keep existing data if refresh fails, reset to default if initial load fails
      if (!isRefresh) {
        setDashboardData(defaultDashboardData);
      }
      
      setSnackbar({
        open: true,
        message: 'Failed to fetch latest data. Please try again.',
        severity: 'error'
      });
    } finally {
      setLoading(false);
      setRefreshing(false);
    }
  };


  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0); // reset to first page
  };
  



useEffect(() => {
  fetchDashboardData();
}, [selectedPeriod, customDateMode]);

  const handlePeriodChange = (period) => {
    setSelectedPeriod(period);
    setCustomDateMode(false);
  };

  const handleCustomDateApply = () => {
    if (startDate && endDate) {
      if (new Date(startDate) > new Date(endDate)) {
        setSnackbar({
          open: true,
          message: 'Start date must be before end date',
          severity: 'error'
        });
        return;
      }
      setCustomDateMode(true);
      fetchDashboardData();
    } else {
      setSnackbar({
        open: true,
        message: 'Please select both start and end dates',
        severity: 'warning'
      });
    }
  };

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const StatCard = ({ title, value, icon, color, subtitle, growth }) => (
    <Card 
      sx={{ 
        height: '100%',
        background: `linear-gradient(135deg, ${color}15 0%, ${color}05 100%)`,
        border: `1px solid ${color}30`,
        transition: 'all 0.3s ease',
        '&:hover': {
          transform: 'translateY(-4px)',
          boxShadow: `0 8px 24px ${color}20`,
        }
      }}
    >
      <CardContent>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 2 }}>
          <Box>
            <Typography variant="body2" color="text.secondary" gutterBottom>
              {title}
            </Typography>
            <Typography variant="h4" fontWeight="bold" color={color}>
              {value}
            </Typography>
          </Box>
          <Avatar 
            sx={{ 
              bgcolor: color, 
              width: 56,
              height: 56,
            }}
          >
            {icon}
          </Avatar>
        </Box>
        
        {subtitle && (
          <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
            {subtitle}
          </Typography>
        )}
        
        {growth !== undefined && (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
            {growth >= 0 ? (
              <TrendingUp sx={{ fontSize: 18, color: 'success.main' }} />
            ) : (
              <TrendingDown sx={{ fontSize: 18, color: 'error.main' }} />
            )}
            <Typography 
              variant="caption" 
              fontWeight="600"
              color={growth >= 0 ? 'success.main' : 'error.main'}
            >
              {Math.abs(growth).toFixed(1)}% from previous period
            </Typography>
          </Box>
        )}
      </CardContent>
    </Card>
  );

  const OrderTypeCard = ({ title, icon, data, color, onViewAll }) => (
    <Card sx={{ height: '100%' }}>
      <CardContent>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
          <Avatar sx={{ bgcolor: `${color}15`, color: color, width: 48, height: 48 }}>
            {icon}
          </Avatar>
          <Box sx={{ flex: 1 }}>
            <Typography variant="h6" fontWeight="bold">
              {title}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Total Orders: {data.total || 0}
            </Typography>
          </Box>
        </Box>

        <Divider sx={{ mb: 2 }} />

        <Grid container spacing={2} sx={{ mb: 2 }}>
          <Grid item xs={6}>
            <Paper variant="outlined" sx={{ p: 1.5, textAlign: 'center' }}>
              <Typography variant="h5" fontWeight="bold" color="warning.main">
                {data.pending || 0}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                Pending
              </Typography>
            </Paper>
          </Grid>
          <Grid item xs={6}>
            <Paper variant="outlined" sx={{ p: 1.5, textAlign: 'center' }}>
              <Typography variant="h5" fontWeight="bold" color="success.main">
                {data.completed || 0}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                Completed
              </Typography>
            </Paper>
          </Grid>
        </Grid>

        <Box sx={{ mb: 2 }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
            <Typography variant="body2" color="text.secondary">
              Completion Rate
            </Typography>
            <Typography variant="body2" fontWeight="600">
              {data.completion_rate || 0}%
            </Typography>
          </Box>
          <LinearProgress 
            variant="determinate" 
            value={data.completion_rate || 0}
            sx={{ 
              height: 8, 
              borderRadius: 1,
              bgcolor: `${color}15`,
              '& .MuiLinearProgress-bar': {
                bgcolor: color,
              }
            }}
          />
        </Box>

        <Box sx={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center',
          p: 1.5,
          bgcolor: 'grey.50',
          borderRadius: 1,
          mb: 2,
        }}>
          <Typography variant="body2" color="text.secondary">
            Total Revenue
          </Typography>
          <Typography variant="h6" fontWeight="bold" color={color}>
            ₹{(data.revenue || 0).toLocaleString('en-IN', { minimumFractionDigits: 2 })}
          </Typography>
        </Box>

        <Button 
          fullWidth 
          variant="outlined" 
          endIcon={<ArrowForward />}
          onClick={() => navigate("/orders-management")}
          sx={{
            borderColor: color,
            color: color,
            '&:hover': {
              borderColor: color,
              bgcolor: `${color}08`,
            }
          }}
        >
          View All Orders
        </Button>
      </CardContent>
    </Card>
  );


  const STATUS_OPTIONS = [
    { label: 'All', value: 'all' },
    { label: 'Pending', value: 'pending' },
    { label: 'Confirmed', value: 'Confirmed' },
    { label: 'Dispatched', value: 'dispatched' },
    { label: 'Delivered', value: 'delivered' },
    { label: 'Cancelled', value: 'cancelled' },
    { label: 'Partially Fulfilled', value: 'partially_fulfilled' },
  ];
  
  const filteredOrders = dashboardData.recentOrders.filter((order) => {
    if (statusFilter === 'all') return true;
    return order.status === statusFilter;
  });
  


  const getStatusChip = (status, type) => {
    const medicineConfigs = {
      awaiting_bill: { label: 'Pending', color: 'warning', icon: <HourglassEmpty sx={{ fontSize: 16 }} /> },
      confirmed: { label: 'Confirmed', color: 'info', icon: <CheckCircle sx={{ fontSize: 16 }} /> },
      dispatched: { label: 'Dispatched', color: 'secondary', icon: <LocalShipping sx={{ fontSize: 16 }} /> },
      delivered: { label: 'Delivered', color: 'success', icon: <CheckCircle sx={{ fontSize: 16 }} /> },
      cancelled: { label: 'Cancelled', color: 'error', icon: <Cancel sx={{ fontSize: 16 }} /> },
      in_progress: { label: 'In Progress', color: 'info', icon: <HourglassEmpty sx={{ fontSize: 16 }} /> },
      partially_fulfilled: { label: 'Partial', color: 'warning', icon: <CallSplit sx={{ fontSize: 16 }} /> },  // ✅ ADD THIS LINE
 
    };

    const diagnosticConfigs = {
      new: { label: 'New', color: 'info', icon: <HourglassEmpty sx={{ fontSize: 16 }} /> },
      Confirmed: { label: 'Confirmed', color: 'primary', icon: <CheckCircle sx={{ fontSize: 16 }} /> },
      'sample-collected': { label: 'Sample Collected', color: 'info', icon: <Biotech sx={{ fontSize: 16 }} /> },
      'test-in-progress': { label: 'Testing', color: 'warning', icon: <Assessment sx={{ fontSize: 16 }} /> },
      'report-ready': { label: 'Report Ready', color: 'secondary', icon: <CheckCircle sx={{ fontSize: 16 }} /> },
      'report-delivered': { label: 'Delivered', color: 'success', icon: <CheckCircle sx={{ fontSize: 16 }} /> },
      closed: { label: 'Closed', color: 'success', icon: <CheckCircle sx={{ fontSize: 16 }} /> },
      cancelled: { label: 'Cancelled', color: 'error', icon: <Cancel sx={{ fontSize: 16 }} /> },
    };
    const nursingConfigs = {
          Pending: {
            label: 'Pending',
            color: 'warning',
            icon: <HourglassEmpty sx={{ fontSize: 16 }} />
          },

          confirmed: {
            label: 'Confirmed',
            color: 'info',
            icon: <CheckCircle sx={{ fontSize: 16 }} />
          },

          assigned: {
            label: 'Assigned',
            color: 'secondary',
            icon: <People sx={{ fontSize: 16 }} />
          },

          in_progress: {
            label: 'In Progress',
            color: 'primary',
            icon: <HourglassEmpty sx={{ fontSize: 16 }} />
          },

          completed: {
            label: 'Completed',
            color: 'success',
            icon: <CheckCircle sx={{ fontSize: 16 }} />
          },

          cancelled: {
            label: 'Cancelled',
            color: 'error',
            icon: <Cancel sx={{ fontSize: 16 }} />
          }
        };
         const packageConfigs = {
          Pending: {
            label: 'Pending',
            color: 'warning',
            icon: <HourglassEmpty sx={{ fontSize: 16 }} />
          },

          confirmed: {
            label: 'Confirmed',
            color: 'info',
            icon: <CheckCircle sx={{ fontSize: 16 }} />
          },

          assigned: {
            label: 'Assigned',
            color: 'secondary',
            icon: <People sx={{ fontSize: 16 }} />
          },

          in_progress: {
            label: 'In Progress',
            color: 'primary',
            icon: <HourglassEmpty sx={{ fontSize: 16 }} />
          },

          completed: {
            label: 'Completed',
            color: 'success',
            icon: <CheckCircle sx={{ fontSize: 16 }} />
          },

          cancelled: {
            label: 'Cancelled',
            color: 'error',
            icon: <Cancel sx={{ fontSize: 16 }} />
          }
        };
    const configs = type === 'Medicine' ? medicineConfigs :type === 'Diagnostic'? diagnosticConfigs:type === 'Package Booking'? packageConfigs:nursingConfigs;
    const config = configs[status] || { label: status, color: 'default', icon: null };
    
    return (
      <Chip 
        label={config.label} 
        color={config.color} 
        size="small"
        icon={config.icon}
        sx={{ fontWeight: 600 }}
      />
    );
  };

  if (loading && !refreshing) {
    return (
      <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: '#f5f7fa' }}>
        <Box sx={{ textAlign: 'center' }}>
          <LinearProgress sx={{ width: 200, mb: 2 }} />
          <Typography variant="h6" color="text.secondary">Loading Dashboard...</Typography>
        </Box>
      </Box>
    );
  }

  return (
    <Box sx={{  minHeight: '100vh', bgcolor: '#f5f7fa', pb: 4, marginLeft:  {
      xs: 0,
      md: "300px",
    }}}>
      {/* Header */}
      {/* <Box sx={{ bgcolor: 'white', borderBottom: '1px solid', borderColor: 'divider', mb: 3 }}> */}
      <Box sx={{ borderBottom: '1px solid', borderColor: 'divider', mb: 3,position: 'fixed',top: {xs: 40, md: 0},left: {xs: 0, md: 250},right: 0,zIndex: 1000,backgroundImage: `
          linear-gradient(135deg, rgba(0,109,119,0.9) 0%, rgba(0, 169, 181, 0.68) 100%),
          url(${bg})
        `,
        backgroundSize: "cover",
        height:"120px",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat" ,}}>
        <Container maxWidth="xl" sx={{ py: 2.5, }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 2 ,}}>
            <Box>
              <Typography variant="h4" fontWeight="bold" color="white" gutterBottom>
                Admin Dashboard
              </Typography>
              <Typography variant="body2" color="white">
                {dashboardData.metadata?.displayRange || 'Welcome back!'} • Monitor and manage your operations
              </Typography>
              {partialDataWarning && (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 1 }}>
                  <ErrorOutline sx={{ fontSize: 16, color: 'warning.main' }} />
                  <Typography variant="caption" color="warning.main">
                    Some data may be incomplete
                  </Typography>
                </Box>
              )}
            </Box>
            <Box sx={{ display: 'flex', gap: 2 }}>
              <Button 
                variant="outlined" 
                startIcon={<Warning />}
                onClick={() => navigate("/complaints-dashboard")}
                sx={{ 
                  borderColor: 'white',
                  color: 'white',
                  '&:hover': { borderColor: '#006D77', bgcolor: '#E0F2F4',color:'#006D77' },
                }}
              >
                Complaints 
              </Button>
              <Tooltip title="Refresh data">
                <IconButton
                  onClick={() => fetchDashboardData(true)}
                  disabled={refreshing}
                  sx={{
                    bgcolor: '#006D77',
                    color: '#fff',
                    '&:hover': { bgcolor: '#005761' },
                    '&:disabled': { bgcolor: '#ccc' }
                  }}
                >
                  <Refresh sx={{ animation: refreshing ? 'spin 1s linear infinite' : 'none' }} />
                </IconButton>
              </Tooltip>
            </Box>
          </Box>
        </Container>
      </Box>

      {/* <Container maxWidth="xl"> */}
      <Container maxWidth="xl" sx={{ 
    pt: '120px'  // Add this - adjust the value based on your header height
  }}>
        {/* Error Alert */}
        {error && (
          <Alert 
            severity="error" 
            sx={{ mb: 3 }} 
            onClose={() => setError(null)}
            action={
              <Button 
                color="inherit" 
                size="small" 
                onClick={() => fetchDashboardData(true)}
              >
                RETRY
              </Button>
            }
          >
            {error}
          </Alert>
        )}

        {/* Date Filter Section */}
        <Card sx={{ mb: 3, bgcolor: 'white' }}>
          <CardContent>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
              <CalendarToday sx={{ color: '#006D77' }} />
              <Typography variant="h6" fontWeight="bold">
                Date Filter
              </Typography>
            </Box>

            <Grid container spacing={2} alignItems="center">
              {/* Quick Period Buttons */}
              <Grid item xs={12} md={6}>
                <ButtonGroup variant="outlined" fullWidth>
                  <Button
                    onClick={() => handlePeriodChange('today')}
                    variant={selectedPeriod === 'today' && !customDateMode ? 'contained' : 'outlined'}
                    sx={{
                      bgcolor: selectedPeriod === 'today' && !customDateMode ? '#006D77' : 'transparent',
                      color: selectedPeriod === 'today' && !customDateMode ? 'white' : '#006D77',
                      '&:hover': {
                        bgcolor: selectedPeriod === 'today' && !customDateMode ? '#005761' : '#006D7710',
                      }
                    }}
                  >
                    Today
                  </Button>
                  <Button
                    onClick={() => handlePeriodChange('week')}
                    variant={selectedPeriod === 'week' && !customDateMode ? 'contained' : 'outlined'}
                    sx={{
                      bgcolor: selectedPeriod === 'week' && !customDateMode ? '#006D77' : 'transparent',
                      color: selectedPeriod === 'week' && !customDateMode ? 'white' : '#006D77',
                      '&:hover': {
                        bgcolor: selectedPeriod === 'week' && !customDateMode ? '#005761' : '#006D7710',
                      }
                    }}
                  >
                    Last 7 Days
                  </Button>
                  <Button
                    onClick={() => handlePeriodChange('month')}
                    variant={selectedPeriod === 'month' && !customDateMode ? 'contained' : 'outlined'}
                    sx={{
                      bgcolor: selectedPeriod === 'month' && !customDateMode ? '#006D77' : 'transparent',
                      color: selectedPeriod === 'month' && !customDateMode ? 'white' : '#006D77',
                      '&:hover': {
                        bgcolor: selectedPeriod === 'month' && !customDateMode ? '#005761' : '#006D7710',
                      }
                    }}
                  >
                    This Month
                  </Button>
                  <Button
                    onClick={() => handlePeriodChange('all')}
                    variant={selectedPeriod === 'all' && !customDateMode ? 'contained' : 'outlined'}
                    sx={{
                      bgcolor: selectedPeriod === 'all' && !customDateMode ? '#006D77' : 'transparent',
                      color: selectedPeriod === 'all' && !customDateMode ? 'white' : '#006D77',
                      '&:hover': {
                        bgcolor: selectedPeriod === 'all' && !customDateMode ? '#005761' : '#006D7710',
                      }
                    }}
                  >
                    All Time
                  </Button>
                </ButtonGroup>
              </Grid>

              {/* Custom Date Range */}
              <Grid item xs={12} md={6}>
                <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
                  <TextField
                    type="date"
                    label="Start Date"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                    InputLabelProps={{ shrink: true }}
                    size="small"
                    fullWidth
                  />
                  <TextField
                    type="date"
                    label="End Date"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                    InputLabelProps={{ shrink: true }}
                    size="small"
                    fullWidth
                  />
                  <Button
                    variant="contained"
                    onClick={handleCustomDateApply}
                    disabled={!startDate || !endDate}
                    sx={{
                      bgcolor: '#006D77',
                      minWidth: '100px',
                      '&:hover': { bgcolor: '#005761' },
                      '&:disabled': { bgcolor: '#ccc' }
                    }}
                  >
                    Apply
                  </Button>
                </Box>
              </Grid>
            </Grid>

            {customDateMode && (
              <Alert severity="info" sx={{ mt: 2 }}>
                Showing data from {startDate} to {endDate}
              </Alert>
            )}
          </CardContent>
        </Card>

        {/* Top KPI Cards */}
        <Grid container spacing={3} sx={{ mb: 3 }}>
          <Grid item xs={12} sm={6} md={3}>
            <StatCard
              title="Total Orders"
              value={(dashboardData.medicineOrders.total || 0) + (dashboardData.diagnosticOrders.total || 0) + (dashboardData.nursingandphysio.total || 0) + (dashboardData.packageBookings.total || 0)}
              icon={<ShoppingCart sx={{ fontSize: 28 }} />}
              color="#006D77"
              subtitle="In selected period"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <StatCard
              title="Pending Orders"
              value={(dashboardData.medicineOrders.pending || 0) + (dashboardData.diagnosticOrders.pending || 0)  + (dashboardData.nursingandphysio.pending || 0) + (dashboardData.packageBookings.pending || 0)}
              icon={<HourglassEmpty sx={{ fontSize: 28 }} />}
              color="#ff9800"
              subtitle="Requires attention"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <StatCard
              title="Total Revenue"
              value={`₹${((dashboardData.totalRevenue || 0) / 1000).toFixed(2)}K`}
              icon={<AttachMoney sx={{ fontSize: 28 }} />}
              color="#4caf50"
              subtitle="In selected period"
              growth={dashboardData.revenueGrowth || 0}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <StatCard
              title="Active Users"
              value={dashboardData.activeUsers || 0}
              icon={<People sx={{ fontSize: 28 }} />}
              color="#2196f3"
              subtitle="In selected period"
              growth={dashboardData.usersGrowth || 0}
            />
          </Grid>
        </Grid>

        {/* Order Type Cards */}
        <Grid container spacing={3} sx={{ mb: 3 }}>
          <Grid item xs={12} md={6}>
            <OrderTypeCard
              title="Medicine Orders"
              icon={<LocalPharmacy sx={{ fontSize: 24 }} />}
              data={dashboardData.medicineOrders}
              color="#006D77"
              onViewAll={() => navigate("/orders-management")}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <OrderTypeCard
              title="Diagnostic Orders"
              icon={<Biotech sx={{ fontSize: 24 }} />}
              data={dashboardData.diagnosticOrders}
              color="#006D77"
              onViewAll={() => navigate("/orders-management")}
            />
          </Grid>
            <Grid item xs={12} md={6}>
            <OrderTypeCard
              title="Nursing and Physio Orders"
              icon={<Healing sx={{ fontSize: 24 }} />}
              data={dashboardData.nursingandphysio}
              color="#006D77"
              onViewAll={() => navigate("/orders-management")}
            />
          </Grid>
           <Grid item xs={12} md={6}>
            <OrderTypeCard
              title="Package Bookings"
              icon={<MedicalServices sx={{ fontSize: 24 }} />}
              data={dashboardData.packageBookings}
              color="#006D77"
              onViewAll={() => navigate("/orders-management")}
            />
          </Grid>
        </Grid>

        {/* Recent Orders Table */}
        <Card sx={{ mb: 3 }}>
          <CardContent>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
              <Box>
                <Typography variant="h6" fontWeight="bold">
                  Recent Orders
                </Typography>
                {/* <Typography variant="body2" color="text.secondary">
                  Showing {filteredOrders.length} of {dashboardData.recentOrders.length} orders
                  {statusFilter !== 'all' && ` (filtered by ${statusFilter})`}
                </Typography> */}
              </Box>
              <Button 
                variant="text" 
                endIcon={<ArrowForward />}
                sx={{ color: '#006D77' }}
                onClick={() => navigate("/orders-management")}
              >
                View All
              </Button>
            </Box>

            <Box sx={{ display: 'flex', gap: 2 }}>
              <TextField
                select
                size="small"
                label="Filter by Status"
                value={statusFilter}
                onChange={(e) => {
                  setStatusFilter(e.target.value);
                  setPage(0); // reset pagination
                }}
                sx={{ minWidth: 180 }}
              >
                {STATUS_OPTIONS.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>
            </Box>


            {dashboardData.recentOrders.length === 0 ? (
              <Alert severity="info">No orders found in the selected period</Alert>
            ) : (
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow sx={{ bgcolor: 'grey.50' }}>
                      <TableCell sx={{ fontWeight: 600 }}>Order ID</TableCell>
                      <TableCell sx={{ fontWeight: 600 }}>Type</TableCell>
                      <TableCell sx={{ fontWeight: 600 }}>Customer</TableCell>
                      <TableCell sx={{ fontWeight: 600 }}>Contact</TableCell>
                      <TableCell sx={{ fontWeight: 600 }}>Amount</TableCell>
                      <TableCell sx={{ fontWeight: 600 }}>Status</TableCell>
               
                      <TableCell sx={{ fontWeight: 600 }}>Date</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {/* {dashboardData.recentOrders.map((order) => ( */}
                    {filteredOrders
                      // .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                      .map((order) => (

                      <TableRow 
                        key={order.id}
                        sx={{ 
                          '&:hover': { bgcolor: 'grey.50' },
                          cursor: 'pointer',
                        }}
                      >
                        <TableCell>
                          <Typography variant="body2" fontWeight="600" color="#006D77">
                            {order.id}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Chip 
                            label={order.type}
                            size="small"
                            variant="outlined"
                            color={
                            order.type === 'Medicine'
                              ? 'primary'
                              : order.type === 'Diagnostic'
                              ? 'secondary'
                              : order.type === 'Package Booking'
                              ? 'success'
                              : 'info'
                          }

                          icon={
                            order.type === 'Medicine'
                              ? <LocalPharmacy sx={{ fontSize: 16 }} />
                              : order.type === 'Diagnostic'
                              ? <Biotech sx={{ fontSize: 16 }} />
                              : order.type === 'Package Booking'
                              ? <MedicalServices sx={{ fontSize: 16 }} />
                              : <Healing sx={{ fontSize: 16 }} />
                          } />
                          
                        </TableCell>
                        <TableCell>
                          <Typography variant="body2">{order.customer}</Typography>
                        </TableCell>
                        <TableCell>
                          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                              <Email sx={{ fontSize: 14, color: 'text.secondary' }} />
                              <Typography variant="caption" color="text.secondary">
                                {order.email}
                              </Typography>
                            </Box>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                              <Phone sx={{ fontSize: 14, color: 'text.secondary' }} />
                              <Typography variant="caption" color="text.secondary">
                                {order.phone}
                              </Typography>
                            </Box>
                          </Box>
                        </TableCell>
                        <TableCell>
                          <Typography variant="body2" fontWeight="600">
                            ₹{(order.amount || 0).toLocaleString('en-IN', { minimumFractionDigits: 2 })}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          {getStatusChip(order.status, order.type)}
                        </TableCell>
                     

                      <TableCell>
                        <Typography variant="body2" color="text.secondary">
                          {new Date(order.date).toLocaleDateString('en-IN', { 
                            day: '2-digit', 
                            month: 'short', 
                            year: 'numeric' 
                          })}
                        </Typography>
                      </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
                {/* <TablePagination
                component="div"
                count={dashboardData.recentOrders.length}
                page={page}
                onPageChange={handleChangePage}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                rowsPerPageOptions={[8]} 
                labelRowsPerPage="Orders per page"
              /> */}
             

              </TableContainer>
            )}
          </CardContent>
        </Card>

        {/* Additional Stats */}
        <Grid container spacing={3}>
          <Grid item xs={12} md={4}>
            <Card>
              <CardContent>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
                  <Avatar sx={{ bgcolor: '#E0F2F4', color: '#006D77', width: 40, height: 40 }}>
                    <Warning />
                  </Avatar>
                  <Box>
                    <Typography variant="h5" fontWeight="bold">
                      {dashboardData.complaints.active || 0}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Active Complaints
                    </Typography>
                  </Box>
                </Box>
                <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 2 }}>
                  Total: {dashboardData.complaints.total || 0} | Resolved: {dashboardData.complaints.resolved || 0}
                </Typography>
                <Button 
                  fullWidth 
                  variant="outlined" 
                  sx={{ 
                    borderColor: '#006D77',
                    color: '#006D77',
                    '&:hover': { borderColor: '#006D77', bgcolor: '#E0F2F4' },
                  }}
                  size="small"
                  onClick={() => navigate("/complaints-dashboard")}
                >
                  Review Complaints
                </Button>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} md={4}>
            <Card>
              <CardContent>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
                  <Avatar sx={{ bgcolor: '#E0F2F4', color: '#006D77', width: 40, height: 40 }}>
                    <Cancel />
                  </Avatar>
                  <Box>
                    <Typography variant="h5" fontWeight="bold">
                      {(dashboardData.medicineOrders.cancelled || 0) + (dashboardData.diagnosticOrders.cancelled || 0)+ (dashboardData.nursingandphysio.cancelled || 0)+ (dashboardData.packageBookings.cancelled || 0)}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Cancelled Orders
                    </Typography>
                  </Box>
                </Box>
                <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 2 }}>
                  Cancellation rate: {
                    (((dashboardData.medicineOrders.cancelled || 0) + (dashboardData.diagnosticOrders.cancelled || 0)+ (dashboardData.nursingandphysio.cancelled || 0)+ (dashboardData.packageBookings.cancelled || 0)) / 
                    ((dashboardData.medicineOrders.total || 1) + (dashboardData.diagnosticOrders.total || 1)+(dashboardData.nursingandphysio.total || 1)+(dashboardData.packageBookings.total || 1)) * 100).toFixed(1)
                  }%
                </Typography>
                <Button 
                  fullWidth 
                  variant="outlined" 
                  onClick={() => navigate("/cancelled-orders")}
                  sx={{ 
                    borderColor: '#006D77',
                    color: '#006D77',
                    '&:hover': { borderColor: '#006D77', bgcolor: '#E0F2F4' },
                  }}
                  size="small"
                >
                  View Details
                </Button>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Container>

      {/* Snackbar for notifications */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Alert 
          onClose={handleCloseSnackbar} 
          severity={snackbar.severity}
          sx={{ width: '100%' }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>

      <style>
        {`
          @keyframes spin {
            from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
          }
        `}
      </style>
    </Box>
  );
};

export default AdminDashboard;